import { Component, OnInit, ChangeDetectorRef, ElementRef, ViewChild, SimpleChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

import * as Models from '../../../../../../src/app/models/commonModels';
import { FormBaseComponent } from '../../../../../../src/app/shared/components/form/form.component';
import { AuthenticationService } from '../../../../../../src/app/shared/services/authentication.service';
import { EnvironmentService } from '../../../../../../src/app/services/environment.service';
import { HelperService } from "../../../../../../src/app/services/helper/helper.service";
import { BannerService } from '../../../../../../src/app/shared/services/banner.service';

import { SettingsState } from '../../../../../../src/app/services/settings/settings.state';
import * as SettingsAction from '../../../../../../src/app/services/settings/settings.action';

import { User } from '../../../../../../src/app/models/user/user';

import { SettingsPreview } from '../../../../../../src/app/models/settings/settings';


import { AldAnonymousState } from "../../../../../../src/app/services/ald-anonymous/ald-anonymous.state";
import * as AldAnonymousActions from "../../../../../../src/app/services/ald-anonymous/ald-anonymous.action";




import * as GarageModels from '../../../../../../src/app/models/garage/garage';
import * as GarageVisitsModels from '../../../../../../src/app/models/garage-visits/garage-visits';

import * as MapModels from '../../../../../../src/app/models/map/map';
import { MapMarker, MapAddressRequestModel } from '../../../../../../src/app/models/map/map';
import { GoogleMapsLoaderService } from '../../../../../../src/app/services/map/google-maps-loader.service';

@Component({
  selector: 'app-garage-select',
  templateUrl: './garage-select.component.html',
  styleUrls: ['./garage-select.component.scss']
})

export class GarageSelectComponent extends FormBaseComponent implements OnInit {

  public requestSetGarage: Models.Request<GarageModels.GaragePreviewModel> = new Models.Request<GarageModels.GaragePreviewModel>();

  public requestGarages: Models.RequestBase  = null;

  public garages: GarageModels.GaragePreviewModel[];

  public selectedGarage: GarageModels.GaragePreviewModel;

  public selectedMarker: MapModels.MapMarker;

  public Markers: MapModels.MapMarker[];

  public Zoom: number = 6;

  // Mapa moze sie wyrenderowac dopiero po zaladowaniu skryptu Google Maps.
  public mapsLoaded = false;

  public isVisibleConfirmationDialog: boolean = false;

  public Lat: number;
  public Lng: number;


  @Select(AldAnonymousState.GarageVisit)
  GarageVisit$: Observable<Models.Response<GarageVisitsModels.GarageVisitModel>>;

  @Select(AldAnonymousState.AvailableGarages)
  AvailableGarages$: Observable<Models.ResponseList<GarageModels.GaragePreviewModel>>;

  constructor(
        private formBuilder: FormBuilder,
        public router: Router,
        public authenticationService: AuthenticationService,
        public store: Store,
        public helperService: HelperService,
        public environmentService: EnvironmentService,
        public changeDetectorRef: ChangeDetectorRef,
        public activatedRoute: ActivatedRoute,
        private bannerService: BannerService,
        private googleMapsLoader: GoogleMapsLoaderService
  ) {

    super(helperService, environmentService, changeDetectorRef);

    //ŁÓDŹ
    this.selectedMarker = {
      Lat: 51.7730971,
      Lng: 19.4105533,
      Www: '',
      Label: '',
      Title: '',
      Draggable: false
    }

    this.Lat = this.selectedMarker.Lat;

    this.Lng = this.selectedMarker.Lng;
  }

  ngOnInit() {

    this.googleMapsLoader.load().then(() => {
      this.mapsLoaded = true;
      this.changeDetectorRef.detectChanges();
    });

    this.subscription.add(
      this.AvailableGarages$.subscribe((data) => {
        if (data && this.requestGarages && data.RequestSignature == this.requestGarages.RequestSignature) {

          this.garages = data.Items;

          this.requestGarages.End();

          this.Markers = this.garages.filter(g => g.Latitude && g.Longitude).map((g) => this.GetMarker(g));
        }
      })
    );

    this.requestGarages = new Models.RequestBase();
    this.requestGarages.Begin()

    this.store.dispatch(new AldAnonymousActions.GaragesGet(this.requestGarages));
  }

  private GetMarker(Garage: GarageModels.GaragePreviewModel): MapModels.MapMarker {

    let marker: MapModels.MapMarker = new MapModels.MapMarker();

    // API zwraca wspolrzedne jako tekst, a @angular/google-maps wymaga liczb.
    marker.Lat = Number(Garage.Latitude);
    marker.Lng = Number(Garage.Longitude);
    marker.Title = Garage.Name;

    return marker;
  }


  onMarkerClik(marker: MapModels.MapMarker) {

    this.selectedGarage = this.garages.filter(g => Number(g.Latitude) === marker.Lat && Number(g.Longitude) === marker.Lng)[0];

    this.selectedMarker = this.GetMarker(this.selectedGarage);

    this.isVisibleConfirmationDialog = true;
  }

  onZoomChange($event) {
    this.Zoom = $event;
  }

  onConfirmClick() {
    this.router.navigate(['/garage-visit', this.selectedGarage.GarageId]);
  }

  onCancelRequestClick() {
    this.isVisibleConfirmationDialog = false;
  }
}
